import React, { Component } from 'react';

import '../App.css';

class Result extends Component {
    render(){
        const {result, resultID} = this.props; 
        return(
            <div className = "Result" style = {question}>
                {result.bool===1 ?(
                    <div>
                        <p>Question: {resultID+1} Right (Answer: {result.correctAnswer})</p>
                    </div>
                ):(
                    <div>
                        <p>Question: {resultID+1} Wrong 
                        (Right Answer: {result.correctAnswer}, You gave: {result.optionValue})
                        </p>
                    </div>
                )}
            </div>
        )
    }
}

const question  = {
    fontSize: '14px',
    display: 'inline-block',
    paddingRight: '2em'
}

export default Result;